/**
 * Back button component script file
 *
 * @package    Containers
 * @author     Roman Kritskiy <rkritskiy@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { FormattedMessage } from 'react-intl';

import ArrowBack from '@material-ui/icons/ArrowBack';

@withRouter
export default class BackButton extends Component {
    /**
     * PropTypes
     */
    static propTypes = {
        to: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        history: PropTypes.object.isRequired,
        onClick: PropTypes.func,
    };

    /**
     * Handle click button
     *
     * @param e
     */
    handleClick = e => {
        e && e.preventDefault();

        const { to, history } = this.props;

        history.push(to);
    };

    /**
     * Render
     *
     * @returns {}
     */
    render() {
        const { title, to, onClick } = this.props;

        return (
            <div>
                <a className="mm-back-button" href={to} onClick={onClick ? onClick : this.handleClick}>
                    <ArrowBack style={{ marginBottom: '-6px' }} />
                    <span>
                        <FormattedMessage id={title} />
                    </span>
                </a>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/BackButton/BackButton.jsx